import EditOpenHouse from "./EditOpenHouse";

export default EditOpenHouse;
